import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-criminal-proceed-grid',
  templateUrl: './criminal-proceed-grid.component.html',
  styleUrls: ['./criminal-proceed-grid.component.css']
})
export class CriminalProceedGridComponent implements OnInit {
  title="Personnel with Criminal proceedings";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/criminal-proceedings/criminal-proceed-grid/criminal-proceed-grid.component.ts